//about
<template>
    <div>
      <v-layout wrap justify-center fill-height  pt-lg-5 pt-md-5 pt-sm-13 pt-14>
        <v-flex xs12 pt-16>
          <!-- <v-layout wrap justify-center pb-5 pt-10>
            <v-flex xs12 sm11 pt-10 pt-xs-10 pt-sm-10 pt-md-0 pt-lg-0 pt-xl-0>
              <v-layout wrap>
               
                <v-flex xs6 sm2>
                  <span
                    style="
                      font-family: poppinsmedium;
                      color: #30b868;
                      font-size: 22px;
                    "
                    >About Uwdefrgthyujikos</span
                  >
                </v-flex>
                <v-flex xs3 sm5 pt-5> <v-divider></v-divider></v-flex>
              </v-layout>
            </v-flex>
          </v-layout> -->
          <v-layout wrap justify-center style="background-color: #f8f8f8">
            <v-flex xs12>
              <v-layout wrap justify-center>
                <v-flex xs11 sm11 px-1>
                  <v-layout wrap justify-space-around py-lg-15 py-md-15  py-sm-4 py-4>
                    <v-flex xs12 sm12 md8 text-start>
                   
                      <span style="
                      font-family: poppinsmedium;
                      color: black;
                      font-size: 22px;
                    ">
                        About Us
                    </span>
                      <v-layout wrap justify-center pr-xs-0 pr-sm-0 pr-md-10 pr-lg-10 pr-xl-10 pt-4>
                        <v-flex xs12 sm12 text-left align-self-center>
                          <span
                            style="
                              color: black;
                              font-family: poppinsregular;
                              font-size: 15px;
                              line-height: 25px;
                              letter-spacing: 1px;
                              text-align: justify;
                            "
                            
                            >The NTFP Information Management System (NTFP-IMS) is an integrated comprehensive platform, provides seamless & updated information availability for different stakeholders involved in NTFP management. The goal is to provide effective connectivity between producers-sellers-buyers within the regulatory environment of the state and the country. Seamless flow of information along with an ease of use for all kinds of users of the system is being targeted. The technology tool shares knowledge on sustainable harvesting practices for several NTFPs; facilitates data-driven sales & operations planning; and promotes regular record keeping of inventory/ sales/ producers. It consists of a Web-Portal and a Mobile Application for interface of producers, forest department and other stakeholders for NTFP enterprise management and knowledge management.
<br>
                            The NTFP-IMS includes a Web-Portal and a Mobile Application to facilitate recording and sharing of information related to NTFPs among different stakeholders and facilitate sustainable management and marketing of NTFPs. In addition, there is an Online Marketplace to facilitate exchange of information between the producers and buyers of NTFPs. The NTFP-IMS can be used for multiple purposes including data recording, analysis of data for management decision, building linkages with buyers in the market, creating awareness on sustainable management of NTFPs.</span
                          >
                        </v-flex>
                      </v-layout>
                      <!-- <v-layout wrap justify-start pt-5 pr-xs-0 pr-sm-0 pr-md-10 pr-lg-10 pr-xl-10>
                        <v-flex xs12 sm6 md3 lg3 text-center v-for="(item, i) in officials" :key="i">
                          <v-layout wrap justify-start>
                            <v-flex
                              xs12
                              sm11
                              data-aos="zoom-in-up"
                              data-aos-ease="ease"
                              data-aos-duration="1500"
                              data-aos-delay="500"
                            >
                              <v-img
                                contain
                                height="50px"
                                :src="mediaUURL + item.image"
                              ></v-img>
                              <br />
                              <span
                                style="
                                  color: #000000;
                                  font-family: RobotoMedium;
                                  font-size: 15px;
                                "
                                >{{ item.name }}</span
                              >
                              <br />
                              <span
                                style="
                                  color: #000000;
                                  font-family: RobotoLight;
                                  font-size: 12px;
                                "
                                >{{ item.designation }}</span
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout> -->
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md4
                      text-right
                      data-aos="zoom-in-up"
                      data-aos-ease="ease"
                      data-aos-duration="1500"
                      data-aos-delay="500" pt-3 
                    >
                      <v-img src="./../../assets/slide1.png">
                        <template v-slot:placeholder>
                          <ImageLoader />
                        </template>
                      </v-img>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout> </v-flex
          ></v-layout>
        </v-flex>
      </v-layout>
    </div>
  </template>
  <script>
//import axios from "axios";
  export default {
    data() {
      return {
        appLoading: false,
        ServerError: false,
        showSnackBar: false,
        timeout: 5000,
        msg: null,
        home:{},
        goals:[],
        officials:[],
        ourStory:{},
      };
    },
    beforeMount() {
    //this.getData();
  },
  methods: {
    // getData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "GET",
    //     url: "/website/content",
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       this.home = response.data.websiteDetails;
    //       this.officials = response.data.officials;
    //       this.ourStory = response.data.websiteDetails.ourStory;
    //       this.goals = response.data.websiteDetails.goals;
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
  },
  };
  </script>